export default __webpack_public_path__ + "static/media/Home1.5d71b7ef.jpg";